import { render, staticRenderFns } from "./datatables_article.vue?vue&type=template&id=28bbc738&"
import script from "./datatables_article.vue?vue&type=script&lang=js&"
export * from "./datatables_article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports